module.exports = __webpack_public_path__ + "static/one_comm_contact-b84eae5889c4d48dd01cdc0ff79b8f35.jpg";